__webpack_require__.p = "/ChopsticksSolver/";